module.exports = __webpack_public_path__ + "static/media/DanskeHuman-MediumItalic.f933be75.eot";